import React, { useEffect, useState, useRef } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import './TextEditor.css';
 
export default function TextEditor({ value, onChange }) {
  const quillRef = useRef(null);
 
  useEffect(() => {
    const quill = quillRef.current.getEditor();
 
    const urlOrEmailRegex =
      /\b((?:https?:\/\/|www\.)[^\s<>]+|[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,})\b/gi;
 
    // 🖊️ Handle typing
    quill.on("text-change", (delta, oldDelta, source) => {
      if (source !== "user") return;
 
      const text = quill.getText();
      let match;
 
      while ((match = urlOrEmailRegex.exec(text)) !== null) {
        const matchedText = match[0];
        const startIndex = match.index;
        const length = matchedText.length;
 
        const formats = quill.getFormat(startIndex, length);
        if (formats.link) continue;
 
        const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(matchedText);
        const href = isEmail
          ? `mailto:${matchedText}`
          : matchedText.startsWith("http")
          ? matchedText
          : `https://${matchedText}`;
 
        quill.formatText(startIndex, length, "link", href, "user");
      }
    });
 
    // 📋 Extend clipboard to preserve formatting
    const Clipboard = Quill.import("modules/clipboard");
    const Delta = Quill.import("delta");
 
    class SmartClipboard extends Clipboard {
      onPaste(e) {
        const clipboardData = e.clipboardData || window.clipboardData;
        const html = clipboardData.getData("text/html");
 
        if (html) {
          e.preventDefault();
          const delta = this.convert(html);
 
          const range = this.quill.getSelection(true);
          this.quill.updateContents(
            new Delta().retain(range.index).delete(range.length).concat(delta),
            "user"
          );
          this.quill.setSelection(range.index + delta.length(), 0);
 
          setTimeout(() => {
            const editorText = this.quill.getText();
            let match;
            while ((match = urlOrEmailRegex.exec(editorText)) !== null) {
              const matchedText = match[0];
              const startIndex = match.index;
              const length = matchedText.length;
              const formats = this.quill.getFormat(startIndex, length);
              if (formats.link) continue;
 
              const isEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(matchedText);
              const href = isEmail
                ? `mailto:${matchedText}`
                : matchedText.startsWith("http")
                ? matchedText
                : `https://${matchedText}`;
              this.quill.formatText(startIndex, length, "link", href, "user");
            }
          }, 0);
 
          return;
        }
 
        super.onPaste(e);
      }
    }
 
    Quill.register("modules/clipboard", SmartClipboard, true);
  }, []);
 
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link"],
      ["clean"],
    ],
  };
 
  return (
<div>
<ReactQuill
        ref={quillRef}
        theme="snow"
        value={value}
        onChange={onChange}
        modules={modules}
      />
</div>
  );
}